import { render, staticRenderFns } from "./goodsEmpty.vue?vue&type=template&id=b484fa08"
import script from "./goodsEmpty.vue?vue&type=script&lang=js"
export * from "./goodsEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports